import "./textblock.scss";

(function () {
    if (document.querySelectorAll(".js-text-block").length > 0) {

        const textBlock = {
            init: function () {
                const abbrTags = document.getElementsByTagName("abbr");
                if (abbrTags.length > 0) {
                    for (const tag of abbrTags) {
                        const array = tag.textContent.split(":");
                        if (array.length > 1 && typeof array[1] !== "undefined") {
                            tag.textContent = array[0];  // text:title
                        }
                    }
                }
            },
        };
        textBlock.init();
    }
})();
